import { render } from "./doc-submitted.vue?vue&type=template&id=6b5032b8&scoped=true"
import script from "./doc-submitted.vue?vue&type=script&lang=js"
export * from "./doc-submitted.vue?vue&type=script&lang=js"

import "./doc-submitted.vue?vue&type=style&index=0&id=6b5032b8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3414373455/src/platform-insurance-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5032b8"]])

export default __exports__